import axios from 'axios'
const isProd = process.env.NODE_ENV === 'production'
const APIHOST = 'https://fc-resource-node-api.krzb.net'
// const APIHOST = 'http://localhost:20030'

export const request = async ({ method = 'GET', data, url, params = {}, headers = {}, isPrefix = true }) => {
  try {
    const res = await axios({
      method,
      url: isPrefix ? `${APIHOST}${url}` : url,
      data,
      timeout: 20 * 1000,
      params: {
        t: new Date().getTime(),
        version: 'v2',
        ...params
      },
      headers: {
        ...headers
      },
    })
    return res.data
  } catch (err) {
    console.log(`request error: ${err}`)
    return null
  }
}
